import { render, staticRenderFns } from "./WriteoffAsset.vue?vue&type=template&id=6838356e&scoped=true&"
import script from "./WriteoffAsset.vue?vue&type=script&lang=js&"
export * from "./WriteoffAsset.vue?vue&type=script&lang=js&"
import style0 from "./WriteoffAsset.vue?vue&type=style&index=0&id=6838356e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6838356e",
  null
  
)

export default component.exports